
import { useState, useEffect } from 'react';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-sm' : 'bg-transparent'}`}>
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex items-center gap-3 cursor-pointer" onClick={() => scrollToSection('inicio')}>
            <img src="https://static.readdy.ai/image/31562a2a45c0a727692c38b1929c3137/3d46b16f5e7faad0d63447f6afafca9f.png" alt="HIPERCLEAN DE AGUASCALIENTES S.A" className="h-10 w-auto" />
            <span className={`font-semibold text-base ${isScrolled ? 'text-gray-900' : 'text-white'}`}>HIPERCLEAN DE AGUASCALIENTES S.A</span>
          </div>

          <div className="hidden md:flex items-center gap-8">
            <button onClick={() => scrollToSection('inicio')} className={`text-sm font-normal transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'}`}>Inicio</button>
            <button onClick={() => scrollToSection('nosotros')} className={`text-sm font-normal transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'}`}>Nosotros</button>
            <button onClick={() => scrollToSection('productos')} className={`text-sm font-normal transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'}`}>Productos</button>
            <button onClick={() => scrollToSection('sectores')} className={`text-sm font-normal transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'}`}>Sectores</button>
            <button onClick={() => scrollToSection('contacto')} className={`text-sm font-normal transition-colors whitespace-nowrap ${isScrolled ? 'text-gray-700 hover:text-blue-600' : 'text-white/90 hover:text-white'}`}>Contacto</button>
          </div>

          <div className="hidden md:flex items-center gap-3">
            <button onClick={() => scrollToSection('contacto')} className="px-5 py-2 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer">
              Solicitar Cotización
            </button>
            <a href="https://wa.me/524492037021" target="_blank" rel="noopener noreferrer" className="px-5 py-2 border border-green-600 text-green-600 text-sm font-medium rounded-lg hover:bg-green-50 transition-colors whitespace-nowrap cursor-pointer">
              <i className="ri-whatsapp-line mr-1.5"></i>WhatsApp
            </a>
          </div>

          <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className="md:hidden p-2 cursor-pointer">
            <i className={`text-2xl ${isScrolled ? 'text-gray-900' : 'text-white'} ${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {isMobileMenuOpen && (
        <div className="md:hidden bg-white/95 backdrop-blur-md border-t border-gray-200">
          <div className="px-4 py-4 space-y-2">
            <button onClick={() => scrollToSection('inicio')} className="block w-full text-left px-4 py-2.5 text-sm font-normal text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Inicio</button>
            <button onClick={() => scrollToSection('nosotros')} className="block w-full text-left px-4 py-2.5 text-sm font-normal text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Nosotros</button>
            <button onClick={() => scrollToSection('productos')} className="block w-full text-left px-4 py-2.5 text-sm font-normal text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Productos</button>
            <button onClick={() => scrollToSection('sectores')} className="block w-full text-left px-4 py-2.5 text-sm font-normal text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Sectores</button>
            <button onClick={() => scrollToSection('contacto')} className="block w-full text-left px-4 py-2.5 text-sm font-normal text-gray-700 hover:bg-gray-50 rounded-lg cursor-pointer whitespace-nowrap">Contacto</button>
            <div className="pt-3 space-y-2">
              <button onClick={() => scrollToSection('contacto')} className="block w-full px-4 py-2.5 bg-blue-600 text-white text-sm font-medium rounded-lg hover:bg-blue-700 transition-colors text-center whitespace-nowrap cursor-pointer">
                Solicitar Cotización
              </button>
              <a href="https://wa.me/524492037021" target="_blank" rel="noopener noreferrer" className="block w-full px-4 py-2.5 border border-green-600 text-green-600 text-sm font-medium rounded-lg hover:bg-green-50 transition-colors text-center whitespace-nowrap cursor-pointer">
                <i className="ri-whatsapp-line mr-1.5"></i>WhatsApp
              </a>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}
